/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { supplyListCommodities } from "../../funcs/supplyListCommodities.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$supplyListCommodities: ToolDefinition = {
  name: "supply-list-commodities",
  description: `List commodities with supply models

Returns a list of all commodities that have supply models
        available. Country codes follow the UN/LOCODE standard:
        https://unece.org/trade/cefact/unlocode-code-list-country-and-territory`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await supplyListCommodities(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
